// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__g2qKw","header":"MessagesList_header__vMeIo","chat":"MessagesList_chat__3G4Nw"};